import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { Store } from './components/Store/Store';
const App = () => {
    return (_jsx(_Fragment, { children: _jsx(Store, {}) }));
};
export default App;
